import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * React Router stand-in for Next.js `Link` — used by @xinosolutions/xs-auth-react/portal
 * in this Vite app (no Next.js dependency).
 */
const Link = forwardRef(function NextLinkShim({ href, ...rest }, ref) {
  const to =
    typeof href === 'string'
      ? href
      : href?.pathname
        ? `${href.pathname}${href.search ?? ''}${href.hash ?? ''}`
        : '/';

  return <RouterLink ref={ref} to={to} {...rest} />;
});

Link.displayName = 'NextLinkShim';

export default Link;
